import {
  ALERTS_CONSENT_TEXT_VERSION,
  DEFAULT_ALERT_FREQUENCY,
  type AlertChannels,
} from '../../types/email-alerts';

/**
 * Turns on the signed-in user's master email-alerts subscription (PUT
 * /api/alerts/subscription). Shared by the SRP alert CTA and the follow-email
 * prompt so consent versioning and the default frequency stay in one place.
 * The server handles consent recording and (when the account email is
 * unverified) the confirmation-email flow — callers should re-check the
 * subscription status afterwards to distinguish active from pendingConfirmation.
 *
 * `channels` is how the alerts reach the user (email, notifications, or both). Omitted, the
 * server keeps the subscription's current channels (email only for a new one), so callers that
 * only mean "turn alerts on" stay unchanged.
 */
export async function subscribeToMasterAlerts(
  locale: 'en' | 'fi' | 'sv',
  channels?: AlertChannels,
): Promise<void> {
  const response = await fetch('/api/alerts/subscription', {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      frequency: DEFAULT_ALERT_FREQUENCY,
      locale,
      consentTextVersion: ALERTS_CONSENT_TEXT_VERSION,
      ...(channels ? { channels } : {}),
    }),
  });
  if (!response.ok) {
    throw new Error(`subscribeToMasterAlerts failed with status ${response.status}`);
  }
}
